import { FC } from "react";
import styled from "@emotion/styled";
import LogoBangbow from "../assets/images/logoBangbow.png";
import IconMsme from "../assets/images/icon-msme.svg";
import { useCoBrand } from "hooks/useCoBrand";

/** โลโก้ร่วม "แบ่งเบา ✕ SME อวดดี" — ไม่โชว์อะไรเลยถ้าไม่ได้มาจากเว็บ co-brand */
export const CoBrandLockup: FC<{ size?: "lg" | "sm" }> = ({ size = "sm" }) => {
  const isCoBrand = useCoBrand();
  if (!isCoBrand) return null;

  return (
    <Lockup data-size={size}>
      <img src={LogoBangbow} alt="แบ่งเบา" />
      <span aria-hidden>✕</span>
      <img src={IconMsme} alt="SME อวดดี" />
    </Lockup>
  );
};

/** โลโก้แผงซ้ายของหน้า auth — สลับเป็นโลโก้ร่วมเมื่อมาจากเว็บ co-brand */
export const AuthBrandLogo: FC = () => {
  const isCoBrand = useCoBrand();

  return isCoBrand ? (
    <CoBrandLockup size="lg" />
  ) : (
    <img src={LogoBangbow} alt="Logo" width={300} height={300} loading="lazy" />
  );
};

const Lockup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 0 20px;
  margin-bottom: 8px;

  img {
    height: 44px;
    width: auto;
    object-fit: contain;
  }

  span {
    color: rgba(0, 0, 0, 0.35);
    font-size: 18px;
    font-weight: 300;
  }

  /* แผงซ้าย (desktop) — lockup ตัวเดียวกันแต่ขยายขนาด */
  &[data-size="lg"] {
    gap: 32px;
    margin-bottom: 0;

    img {
      height: 130px;
    }

    span {
      font-size: 44px;
    }
  }
`;
